import * as React from 'react';
import Overlay from './Overlay';
import styled from 'styled-components';
const modal = (props) => {
    console.log("render modal");
    const buttons = () => {
        if (props.buttons) {
            return (React.createElement("div", { className: "buttons" }, props.buttons));
        }
        return null;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Overlay, { show: props.show, clicked: props.handlers.closeModal }),
        React.createElement(ModalStyle, { style: { display: props.show ? 'block' : 'none' } },
            React.createElement("h1", null, props.title),
            React.createElement("div", { className: "content" }, props.children),
            buttons())));
};
export default modal;
const ModalStyle = styled.div `
  background-color: rgba(40, 40, 40, 0.95);
  border: 1px solid #777;
  box-shadow: 10px 10px 15px black;
  box-sizing: border-box;
  left: 25%;
  position: fixed;
  top: 10%;
  transition: all 0.3s ease-out;
  width: 50%;
  z-index: 500;

  h1 {
    background-color: #000;
    font-weight: normal;
    margin: 0;
    padding: 20px;
  }

  .content,
  .buttons {
    padding: 16px;
  }
`;
//# sourceMappingURL=Modal.js.map


// WEBPACK FOOTER //
// ./src/components/Modal.js